import Prism from "prismjs";

// Import core and extended language definitions in dependency order
import "prismjs/components/prism-markup.js";
import "prismjs/components/prism-css.js";
import "prismjs/components/prism-clike.js";
import "prismjs/components/prism-javascript.js";
import "prismjs/components/prism-typescript.js";
import "prismjs/components/prism-markup-templating.js";
import "prismjs/components/prism-jsx.js";
import "prismjs/components/prism-tsx.js";
import "prismjs/components/prism-python.js";
import "prismjs/components/prism-bash.js";
import "prismjs/components/prism-json.js";
import "prismjs/components/prism-yaml.js";
import "prismjs/components/prism-sql.js";
import "prismjs/components/prism-c.js";
import "prismjs/components/prism-cpp.js";
import "prismjs/components/prism-csharp.js";
import "prismjs/components/prism-java.js";
import "prismjs/components/prism-scala.js";
import "prismjs/components/prism-ruby.js";
import "prismjs/components/prism-php.js";
import "prismjs/components/prism-go.js";
import "prismjs/components/prism-rust.js";
import "prismjs/components/prism-markdown.js";
import "prismjs/components/prism-docker.js";
import "prismjs/components/prism-toml.js";
import "prismjs/components/prism-graphql.js";
import "prismjs/components/prism-swift.js";
import "prismjs/components/prism-kotlin.js";
import "prismjs/components/prism-dart.js";
import "prismjs/components/prism-scss.js";
import "prismjs/components/prism-diff.js";
import "prismjs/components/prism-ini.js";
import "prismjs/components/prism-nginx.js";
import "prismjs/components/prism-git.js";
import "prismjs/components/prism-lua.js";
import "prismjs/components/prism-powershell.js";
import "prismjs/components/prism-r.js";
import "prismjs/components/prism-wasm.js";
import "prismjs/components/prism-latex.js";
import "prismjs/components/prism-haskell.js";
import "prismjs/components/prism-elixir.js";
import "prismjs/components/prism-clojure.js";
import "prismjs/components/prism-perl.js";
import "prismjs/components/prism-makefile.js";
import "prismjs/components/prism-cmake.js";
import "prismjs/components/prism-http.js";
import "prismjs/components/prism-regex.js";

// Map custom language aliases to standard Prism definitions
if (Prism.languages.cpp) {
    Prism.languages["c++"] = Prism.languages.cpp;
    Prism.languages.cc = Prism.languages.cpp;
    Prism.languages.cxx = Prism.languages.cpp;
    Prism.languages.hpp = Prism.languages.cpp;
}
if (Prism.languages.csharp) {
    Prism.languages["c#"] = Prism.languages.csharp;
    Prism.languages.cs = Prism.languages.csharp;
    Prism.languages.dotnet = Prism.languages.csharp;
}
if (Prism.languages.go) {
    Prism.languages.golang = Prism.languages.go;
}
if (Prism.languages.bash) {
    Prism.languages.sh = Prism.languages.bash;
    Prism.languages.zsh = Prism.languages.bash;
    Prism.languages.shell = Prism.languages.bash;
}
if (Prism.languages.powershell) {
    Prism.languages.ps = Prism.languages.powershell;
    Prism.languages.ps1 = Prism.languages.powershell;
}
if (Prism.languages.yaml) {
    Prism.languages.yml = Prism.languages.yaml;
}
if (Prism.languages.rust) {
    Prism.languages.rs = Prism.languages.rust;
}
if (Prism.languages.ruby) {
    Prism.languages.rb = Prism.languages.ruby;
}
if (Prism.languages.python) {
    Prism.languages.py = Prism.languages.python;
}
if (Prism.languages.markup) {
    Prism.languages.html = Prism.languages.markup;
    Prism.languages.htm = Prism.languages.markup;
    Prism.languages.xml = Prism.languages.markup;
    Prism.languages.svg = Prism.languages.markup;
}
if (Prism.languages.markdown) {
    Prism.languages.md = Prism.languages.markdown;
}
if (Prism.languages.docker) {
    Prism.languages.dockerfile = Prism.languages.docker;
}
if (Prism.languages.latex) {
    Prism.languages.tex = Prism.languages.latex;
}

// Register custom Mahjong syntax for Prism
Prism.languages.mahjong = {
    "mahjong-man": {
        pattern: /[0-9]+[mM]/,
        alias: "number"
    },
    "mahjong-pin": {
        pattern: /[0-9]+[pP]/,
        alias: "string"
    },
    "mahjong-sou": {
        pattern: /[0-9]+[sS]/,
        alias: "keyword"
    },
    "mahjong-honor": {
        pattern: /(?:[1-7]+[zZ]|(?:ton|nan|shaa|pei|haku|hatsu|chun|east|south|west|north|white|green|red)\b)/i,
        alias: "function"
    },
    "mahjong-dora": {
        pattern: /(?:0[mps]|r5[mps]|5[mps]r|5[mps]\*)/i,
        alias: "important"
    },
    "mahjong-separator": {
        pattern: /[\s,|+\[\]]+/,
        alias: "punctuation"
    }
};
Prism.languages.riichi = Prism.languages.mahjong;
Prism.languages.tiles = Prism.languages.mahjong;
Prism.languages.mj = Prism.languages.mahjong;

/**
 * Maps language aliases to display names
 */
const LANGUAGE_DISPLAY_NAMES = {
    js: "JavaScript",
    javascript: "JavaScript",
    ts: "TypeScript",
    typescript: "TypeScript",
    jsx: "React JSX",
    tsx: "React TSX",
    py: "Python",
    python: "Python",
    html: "HTML",
    htm: "HTML",
    xml: "XML",
    svg: "SVG",
    markup: "HTML",
    css: "CSS",
    scss: "SCSS",
    sass: "Sass",
    less: "Less",
    bash: "Bash",
    sh: "Shell",
    zsh: "Zsh",
    shell: "Shell",
    json: "JSON",
    yaml: "YAML",
    yml: "YAML",
    toml: "TOML",
    sql: "SQL",
    c: "C",
    cpp: "C++",
    "c++": "C++",
    cc: "C++",
    cs: "C#",
    "c#": "C#",
    csharp: "C#",
    dotnet: ".NET",
    java: "Java",
    go: "Go",
    golang: "Go",
    rs: "Rust",
    rust: "Rust",
    rb: "Ruby",
    ruby: "Ruby",
    php: "PHP",
    md: "Markdown",
    markdown: "Markdown",
    docker: "Docker",
    dockerfile: "Dockerfile",
    graphql: "GraphQL",
    gql: "GraphQL",
    swift: "Swift",
    kt: "Kotlin",
    kotlin: "Kotlin",
    dart: "Dart",
    diff: "Diff",
    git: "Git",
    lua: "Lua",
    ps1: "PowerShell",
    powershell: "PowerShell",
    ps: "PowerShell",
    r: "R",
    wasm: "WebAssembly",
    latex: "LaTeX",
    tex: "LaTeX",
    haskell: "Haskell",
    elixir: "Elixir",
    clojure: "Clojure",
    scala: "Scala",
    perl: "Perl",
    makefile: "Makefile",
    cmake: "CMake",
    http: "HTTP",
    regex: "Regex",
    mahjong: "Mahjong",
    riichi: "Riichi Mahjong",
    tiles: "Mahjong Tiles",
    mj: "Mahjong"
};

/**
 * Available theme slugs
 */
const KNOWN_THEMES = [
    "atom-dark", "dracula", "nord", "one-dark", "one-light", "vsc-dark-plus",
    "ghcolors", "night-owl", "material-dark", "material-light", "material-oceanic",
    "gruvbox-dark", "gruvbox-light", "solarized-dark-atom", "solarizedlight",
    "synthwave84", "shades-of-purple", "darcula", "okaidia", "tomorrow", "twilight",
    "prism", "a11y-dark", "coldark-dark", "coldark-cold", "duotone-dark",
    "duotone-light", "duotone-sea", "duotone-space", "duotone-earth", "duotone-forest",
    "hopscotch", "lucario", "pojoaque", "xonokai", "z-touch", "cb", "vs", "funky",
    "coy", "coy-without-shadows", "base16-ateliersulphurpool-light", "holi-theme", "dark"
];

/**
 * Normalizes a theme string to slug
 */
function normalizeThemeSlug(themeStr) {
    if (!themeStr) return "atom-dark";
    const slug = themeStr.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
    if (slug === "vs-code-dark-plus" || slug === "vscode-dark-plus") return "vsc-dark-plus";
    if (slug === "github-colors" || slug === "github") return "ghcolors";
    if (slug === "synthwave-84") return "synthwave84";
    if (slug === "prism-default") return "prism";
    if (slug === "tomorrow-night") return "tomorrow";
    if (slug === "solarized-light") return "solarizedlight";
    return slug;
}

/**
 * Extract language identifier and any inline options from element
 */
function parseCodeMeta(element) {
    if (!element) return { lang: "", theme: "" };

    let lang = "";
    let theme = "";

    const classes = (element.className || "").split(/\s+/);
    for (const cls of classes) {
        if (cls.startsWith("language-")) {
            lang = cls.substring(9).toLowerCase();
        } else if (cls.startsWith("lang-")) {
            lang = cls.substring(5).toLowerCase();
        } else if (cls.startsWith("theme-")) {
            theme = cls.substring(6).toLowerCase();
        } else if (KNOWN_THEMES.includes(cls.toLowerCase())) {
            theme = cls.toLowerCase();
        }
    }

    // Check data attributes
    if (!theme && element.dataset && element.dataset.syntaxTheme) {
        theme = element.dataset.syntaxTheme;
    }

    return { lang, theme };
}

/**
 * Add line numbers to code element if not already present
 */
function applyLineNumbers(codeElement) {
    const text = codeElement.textContent || "";
    const lines = text.trimEnd().split("\n");
    if (lines.length <= 1) return;

    const pre = codeElement.parentElement;
    if (!pre || pre.querySelector(".gh-line-numbers")) return;

    pre.classList.add("has-line-numbers");

    const lineNumSpan = document.createElement("span");
    lineNumSpan.className = "gh-line-numbers";
    lineNumSpan.setAttribute("aria-hidden", "true");

    let numbersHtml = "";
    for (let i = 1; i <= lines.length; i++) {
        numbersHtml += `<span>${i}</span>`;
    }
    lineNumSpan.innerHTML = numbersHtml;
    pre.insertBefore(lineNumSpan, codeElement);
}

/**
 * Build Header Bar (Language Name + Copy Button)
 */
function createHeaderBar(codeElement, language) {
    const header = document.createElement("div");
    header.className = "gh-code-header";

    // Language Badge
    const langBadge = document.createElement("span");
    langBadge.className = "gh-code-lang";
    const displayName = LANGUAGE_DISPLAY_NAMES[language] || (language ? language.toUpperCase() : "Code");
    langBadge.textContent = displayName;
    header.appendChild(langBadge);

    // Actions container
    const actions = document.createElement("div");
    actions.className = "gh-code-actions";

    // Copy Button
    const copyBtn = document.createElement("button");
    copyBtn.className = "gh-code-copy-btn";
    copyBtn.type = "button";
    copyBtn.setAttribute("aria-label", "Copy code to clipboard");
    copyBtn.innerHTML = `
        <svg class="gh-icon-copy" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
        </svg>
        <svg class="gh-icon-check" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display:none;">
            <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
        <span class="gh-copy-text">Copy</span>
    `;

    copyBtn.addEventListener("click", async () => {
        const textToCopy = codeElement.textContent || "";
        try {
            if (navigator.clipboard && navigator.clipboard.writeText) {
                await navigator.clipboard.writeText(textToCopy);
            } else {
                const textarea = document.createElement("textarea");
                textarea.value = textToCopy;
                textarea.style.position = "fixed";
                textarea.style.opacity = "0";
                document.body.appendChild(textarea);
                textarea.select();
                document.execCommand("copy");
                document.body.removeChild(textarea);
            }

            copyBtn.classList.add("is-copied");
            const copyIcon = copyBtn.querySelector(".gh-icon-copy");
            const checkIcon = copyBtn.querySelector(".gh-icon-check");
            const textSpan = copyBtn.querySelector(".gh-copy-text");

            if (copyIcon) copyIcon.style.display = "none";
            if (checkIcon) checkIcon.style.display = "inline-block";
            if (textSpan) textSpan.textContent = "Copied!";

            setTimeout(() => {
                copyBtn.classList.remove("is-copied");
                if (copyIcon) copyIcon.style.display = "inline-block";
                if (checkIcon) checkIcon.style.display = "none";
                if (textSpan) textSpan.textContent = "Copy";
            }, 2000);
        } catch (err) {
            console.error("Failed to copy code: ", err);
        }
    });

    actions.appendChild(copyBtn);
    header.appendChild(actions);

    return header;
}

/**
 * Enhances all code blocks on the page
 */
export default function initCodeHighlighting(options = {}) {
    const config = Object.assign({
        container: document,
        enableLineNumbers: true,
        enableCopyButton: true,
        enableHeader: true,
    }, options);

    // Synchronize global theme attribute if set on body or meta
    const metaTheme = document.querySelector('meta[name="ghost-syntax-theme"]');
    const globalThemeRaw = document.body.dataset.syntaxTheme ||
                          (metaTheme ? metaTheme.getAttribute("content") : "") ||
                          document.documentElement.dataset.syntaxTheme ||
                          "Atom Dark";

    const globalSlug = normalizeThemeSlug(globalThemeRaw);
    if (!document.body.dataset.syntaxTheme) {
        document.body.setAttribute("data-syntax-theme", globalThemeRaw);
    }
    document.body.setAttribute("data-syntax-theme-slug", globalSlug);

    const codeBlocks = config.container.querySelectorAll("pre > code");

    codeBlocks.forEach((codeEl) => {
        const pre = codeEl.parentElement;
        if (!pre || pre.dataset.highlighted) return;

        // Skip mahjong code blocks that will be transformed to tiles
        const metaCode = parseCodeMeta(codeEl);
        const metaPre = parseCodeMeta(pre);

        const rawLang = metaCode.lang || metaPre.lang || "";
        const blockTheme = metaCode.theme || metaPre.theme || "";

        if (["mahjong", "riichi", "tiles", "mj"].includes(rawLang) && !pre.classList.contains("keep-code")) {
            return;
        }

        pre.dataset.highlighted = "true";

        // Determine language grammar in Prism
        let resolvedLang = rawLang;
        if (!Prism.languages[resolvedLang]) {
            if (rawLang === "js") resolvedLang = "javascript";
            else if (rawLang === "ts") resolvedLang = "typescript";
            else if (rawLang === "py") resolvedLang = "python";
            else if (rawLang === "c++" || rawLang === "cc") resolvedLang = "cpp";
            else if (rawLang === "c#" || rawLang === "cs") resolvedLang = "csharp";
            else if (rawLang === "golang") resolvedLang = "go";
            else if (rawLang === "sh" || rawLang === "zsh" || rawLang === "shell") resolvedLang = "bash";
            else if (rawLang === "yml") resolvedLang = "yaml";
            else if (rawLang === "rs") resolvedLang = "rust";
            else if (rawLang === "rb") resolvedLang = "ruby";
            else if (rawLang === "html" || rawLang === "htm" || rawLang === "xml" || rawLang === "svg") resolvedLang = "markup";
            else if (rawLang === "md") resolvedLang = "markdown";
            else if (rawLang === "docker") resolvedLang = "dockerfile";
            else if (rawLang === "ps" || rawLang === "ps1") resolvedLang = "powershell";
        }

        // Set classes on code and pre
        if (resolvedLang) {
            codeEl.classList.add(`language-${resolvedLang}`);
            pre.classList.add(`language-${resolvedLang}`);
        } else {
            codeEl.classList.add("language-none");
            pre.classList.add("language-none");
        }

        // Run Prism highlight on this block
        Prism.highlightElement(codeEl);

        // Add line numbers if enabled
        if (config.enableLineNumbers) {
            applyLineNumbers(codeEl);
        }

        // Wrap pre in code container with header
        if (config.enableHeader || config.enableCopyButton) {
            const wrapper = document.createElement("div");
            wrapper.className = "gh-code-block";

            // Set block-level theme if explicitly specified
            if (blockTheme) {
                wrapper.setAttribute("data-syntax-theme", blockTheme);
            }

            // Insert wrapper before pre and move pre into wrapper
            pre.parentNode.insertBefore(wrapper, pre);

            const header = createHeaderBar(codeEl, rawLang || resolvedLang);
            wrapper.appendChild(header);
            wrapper.appendChild(pre);
        }
    });
}
